import { Component, OnInit } from '@angular/core';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'dl-daily-summary-report',
  templateUrl: './daily-summary-report.component.html',
  styleUrls: ['./daily-summary-report.component.scss']
})
export class DailySummaryReportComponent implements OnInit {
  public sendToControl = new FormControl('',[ Validators.required, Validators.email]);
  constructor(
     private _QnSbnDataService: QnSbnDataService,
  ) {  
     this._QnSbnDataService.DailyReportEnabled$.subscribe(
       res=>{
         this.isDailySummaryEnabled = res;
       }
     )
  }
  public isDailySummaryEnabled: boolean = false;
  public reportContent = ['Deliveries', 'Failures', 'Feedback Submitted'];
  public selected = new Set<string>();
  public sendTo: string;
  public storedData: any;
  public emailRequired: boolean = false;
  public invalidEmail: boolean = false;

  ngOnInit(): void {
    this._QnSbnDataService.mappingData$.subscribe(storeData=>{
      this.storedData = storeData;
    })
    this._QnSbnDataService.mappingData$.subscribe(observer=>{
      if(!this._QnSbnDataService.isEmpty(observer['dailyReportContent'])){
        const selectedContent = observer['dailyReportContent'];
        this.selected = new Set<string>(selectedContent);
      }
      if(!this._QnSbnDataService.isEmpty(observer['dailyReportSendTo'])){
        this.sendTo = observer['dailyReportSendTo'].sendTo;
        this.sendToControl.setValue(this.sendTo, { emitEvent: false });
      }
    })
      this.sendToControl.valueChanges.subscribe(value=>{
        this.sendTo = value;
         const strictEmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(this.sendTo == ""){
          this._QnSbnDataService.getMappedQnsbnData({},"DailySummaryReportSendTo");
          this.emailRequired = true;
        }else{
          this._QnSbnDataService.getMappedQnsbnData({sendTo: this.sendTo},"DailySummaryReportSendTo");
            if(this.sendTo.length > 1 && (this.sendToControl.errors || !strictEmailPattern.test(this.sendTo))){
              this.invalidEmail = true;
            }else{
              this.invalidEmail = false;
            }
          this.emailRequired = false;
        }      
    })
  }

  public toggleEnable(checked) {
    this._QnSbnDataService.DailyReportEnabled$.next(checked)
    this._QnSbnDataService.getMappedQnsbnData({checked},"EnableDailySummaryReport");
  }

  public contentSelection(options, checked){
     if (checked) {
      this.selected.add(options);
    } else {
      this.selected.delete(options);
    }
     this._QnSbnDataService.getMappedQnsbnData(Array.from(this.selected),"DailySummaryReportContent");
    if(
        (!this._QnSbnDataService.isEmpty(this.storedData.dailyReportSendTo) && this.storedData.dailyReportSendTo !== "")
      ){
        this.emailRequired = false;
      }else{
        this.emailRequired = true;
      }
  }

  public contentAllSelection(checked){
     if (checked) {
      this.reportContent.forEach(option => this.selected.add(option));
    } else {
      this.selected.clear();
    }
    this._QnSbnDataService.getMappedQnsbnData(Array.from(this.selected),"DailySummaryReportContent");
    if(
        (!this._QnSbnDataService.isEmpty(this.storedData.dailyReportSendTo) && this.storedData.dailyReportSendTo !== "")
      ){
        this.emailRequired = false;
      }else{
        this.emailRequired = true;
      }
  }

  public isAllSelected(){
    return this.selected.size === this.reportContent.length;
  }
}
